import React from 'react';
import { Card } from 'react-bootstrap';

interface ResultDisplayProps {
    result: number | string | null;
}

const ResultDisplay: React.FC<ResultDisplayProps> = ({ result }) => {
    return result !== null ? (
        <Card.Text className="mt-3">
            結果: <strong>{result}</strong>
        </Card.Text>
    ) : null;
};

export default ResultDisplay;
